var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article"},[_c('h1',{staticClass:"article__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"article__content"},[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }